import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { IAppointmentPatientSpeciesLookupRepository } from '../../domain/repositories/appointment-patient-species-lookup.repository';
import { AppointmentPatientSpeciesLookupRemoteDatasource } from '../datasources/remote/appointment-patient-species-lookup.remote-datasource';

@Injectable()
export class AppointmentPatientSpeciesLookupRepositoryImpl implements IAppointmentPatientSpeciesLookupRepository {
  private readonly datasource = inject(AppointmentPatientSpeciesLookupRemoteDatasource);

  // Single-field passthrough (ExternalId -> SpeciesId) -- no dedicated mapper class, mirroring how
  // thin this projection is (just PatientSpeciesRefDto.SpeciesId, no nested shape to reconcile).
  public getSpeciesById(patientId: string): Observable<number | null> {
    return this.datasource.getById(patientId).pipe(
      map((dto) => dto.SpeciesId ?? null),
      catchError(() => of(null)),
    );
  }

  // Seeds every requested id with null upfront so ids the backend omits (not found) still resolve
  // to a definite "unknown" entry instead of being absent from the map.
  public getSpeciesByIds(patientIds: readonly string[]): Observable<ReadonlyMap<string, number | null>> {
    return this.datasource.getByIds(patientIds).pipe(
      map((dto) => {
        const result = new Map<string, number | null>(patientIds.map((id) => [id, null]));
        for (const item of dto.Items) {
          result.set(item.ExternalId, item.SpeciesId ?? null);
        }
        return result;
      }),
      catchError(() => of(new Map(patientIds.map((id) => [id, null])))),
    );
  }
}
